function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.666667%,48.235294%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 4.5 0 L 25.5 0 C 27.984375 0 30 2.015625 30 4.5 L 30 25.5 C 30 27.984375 27.984375 30 25.5 30 L 4.5 30 C 2.015625 30 0 27.984375 0 25.5 L 0 4.5 C 0 2.015625 2.015625 0 4.5 0 Z M 4.5 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 154.999478 201.99932 L 96.999673 201.99932 C 95.666344 201.932653 94.466348 202.73265 93.999683 203.999313 L 66.999774 344.998838 C 66.999774 347.998828 69.999764 347.998828 69.999764 347.998828 L 99.999663 347.998828 C 102.999653 347.998828 102.999653 345.998835 102.999653 345.998835 L 109.999629 310.998952 L 136.999539 310.998952 C 178.999397 310.998952 199.999326 282.999047 204.999309 257.999131 C 209.999293 232.999215 205.999306 201.99932 154.999478 201.99932 Z M 167.999434 255.999138 C 163.999448 274.999074 150.999491 282.999047 132.999552 282.999047 L 114.999613 282.999047 L 125.999576 229.999225 L 143.999515 229.999225 C 170.999424 229.999225 169.999427 239.999192 167.999434 255.999138 Z M 167.999434 255.999138 ",
    transform: "matrix(0.0585939,0,0,0.0585939,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 274.999074 310.998952 C 270.999087 310.998952 271.999084 306.998966 271.999084 306.998966 L 283.999043 245.999171 C 283.999043 237.999198 289.999023 229.999225 265.999104 230.999222 L 247.999165 230.999222 L 232.999215 308.998959 C 232.999215 308.998959 232.999215 311.998949 228.999229 311.998949 L 199.999326 311.998949 C 196.999336 311.998949 196.999336 308.998959 196.999336 308.998959 L 224.999242 167.999434 C 224.999242 167.999434 224.999242 165.999441 228.999229 165.999441 L 258.999128 165.999441 C 261.999117 165.999441 260.999121 168.999431 260.999121 168.999431 L 253.999144 202.999316 L 279.999057 202.999316 C 315.998936 202.999316 324.998905 219.999259 321.998915 239.999192 L 308.998959 308.998959 C 308.998959 308.998959 308.998959 311.998949 303.998976 311.998949 Z M 274.999074 310.998952 ",
    transform: "matrix(0.0585939,0,0,0.0585939,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 154.999481 201.99932 L 96.999677 201.99932 C 95.666348 201.932653 94.466352 202.73265 93.999687 203.999313 L 66.999778 344.998838 C 66.999778 347.998828 69.999768 347.998828 69.999768 347.998828 L 99.999667 347.998828 C 102.999656 347.998828 102.999656 345.998835 102.999656 345.998835 L 109.999633 310.998952 L 136.999542 310.998952 C 178.9994 310.998952 199.99933 282.999047 204.999313 257.999131 C 209.999296 232.999215 205.999309 201.99932 154.999481 201.99932 Z M 167.999437 255.999138 C 163.999451 274.999074 150.999495 282.999047 132.999555 282.999047 L 114.999616 282.999047 L 125.999579 229.999225 L 143.999518 229.999225 C 170.999427 229.999225 169.999431 239.999192 167.999437 255.999138 Z M 167.999437 255.999138 ",
    transform: "matrix(0.0585939,0,0,0.0585939,14.003906,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.2754ae8e94ec4eac2973cf5419fea507.svg";
export { ForwardRef as ReactComponent };